var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("BlBackdrop", { attrs: { title: _vm.title, footer: false } }, [
        _vm.step === "select_method"
          ? _c("div", { staticClass: "flex flex-col gap-8 pb-8" }, [
              _c(
                "div",
                { staticClass: "grid items-center grid-cols-2 gap-2 px-8" },
                _vm._l(_vm.sourceOptions, function(opt) {
                  return _c(
                    "div",
                    {
                      key: opt.value,
                      staticClass:
                        "flex flex-col items-center px-5 py-5 text-center rounded cursor-pointer",
                      class: [
                        _vm.source === opt.value
                          ? "border-2 border-light-purple bg-slate-100"
                          : "border border-slate-400 bg-pure-white m-px"
                      ],
                      on: {
                        click: function($event) {
                          _vm.source = opt.value
                        }
                      }
                    },
                    [
                      _c("BlTextSubtitle3", {
                        class: {
                          "text-light-purple": _vm.source === opt.value
                        },
                        attrs: { text: opt.title }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody3", {
                        staticClass: "whitespace-pre-line w-50",
                        attrs: { text: opt.description }
                      })
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center justify-between gap-4 px-8" },
                [
                  _c("BlInputButton", {
                    attrs: { type: "plain", label: "Cancel" },
                    on: {
                      clicked: function($event) {
                        return _vm.$emit("close-modal")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: { label: "Next", disabled: _vm.source === "" },
                    on: { clicked: _vm.onSelectMethod }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "manual_input"
          ? _c("div", { staticClass: "flex flex-col gap-4 pb-8" }, [
              _c("div", { staticClass: "px-8" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex h-10 px-1 py-1 rounded-lg bg-slate-400"
                  },
                  _vm._l(_vm.typeOptions, function(opt) {
                    return _c(
                      "div",
                      {
                        key: opt.value,
                        staticClass:
                          "flex items-center justify-center w-full transition-all duration-300 rounded cursor-pointer",
                        class: [
                          _vm.typeInput === opt.value
                            ? "bg-pure-white"
                            : "bg-slate-400"
                        ],
                        on: {
                          click: function($event) {
                            _vm.typeInput = opt.value
                          }
                        }
                      },
                      [_c("BlTextSubtitle3", { attrs: { text: opt.label } })],
                      1
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex flex-col gap-4",
                  class: {
                    "overflow-y-auto":
                      _vm.typeInput === "CreditTransaction::Addition" ||
                      (_vm.typeInput === "CreditTransaction::Subtraction" &&
                        _vm.transactionIdInput)
                  },
                  style: { width: "40rem", maxHeight: "calc(100vh - 16rem)" }
                },
                [
                  _vm.typeInput === "CreditTransaction::Addition"
                    ? _c(
                        "div",
                        { staticClass: "flex flex-col gap-4 px-8" },
                        [
                          _c("BlSelectBox", {
                            attrs: {
                              label: "Item",
                              asterisk: "",
                              placeholder: "Select item",
                              options: _vm.additionPackageItemOptions
                            },
                            on: {
                              change: function($event) {
                                _vm.additionPackageItemIdInput = $event
                              }
                            },
                            model: {
                              value: _vm.additionPackageItemIdInput,
                              callback: function($$v) {
                                _vm.additionPackageItemIdInput = $$v
                              },
                              expression: "additionPackageItemIdInput"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "flex" }, [
                              _c(
                                "div",
                                { staticClass: "px-2 rounded-t bg-slate-400" },
                                [
                                  _c("BlTextBody3", {
                                    attrs: { text: "Session credits" }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col items-center gap-1 px-4 py-3 rounded rounded-tl-none bg-slate-200"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex items-center gap-3" },
                                  [
                                    _c("BlInputButton", {
                                      staticClass: "rounded-full",
                                      attrs: {
                                        type: "outlined",
                                        icon: "minus",
                                        dense: "",
                                        disabled:
                                          _vm.additionSessionCreditInput <= 0
                                      },
                                      on: {
                                        clicked: function($event) {
                                          _vm.additionSessionCreditInput =
                                            Number(
                                              _vm.additionSessionCreditInput
                                            ) - 1
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.additionSessionCreditInput,
                                          expression:
                                            "additionSessionCreditInput"
                                        }
                                      ],
                                      staticClass:
                                        "flex items-center justify-center h-20 text-6xl font-bold text-center border rounded outline-none w-104 border-slate-500 text-dark-purple-100 focus:border-light-purple",
                                      class: [
                                        _vm.additionSessionCreditInput <= 0
                                          ? "text-error-300"
                                          : "text-dark-purple-100"
                                      ],
                                      attrs: {
                                        type: "number",
                                        name: "credit_count",
                                        id: "credit_count",
                                        min: 1
                                      },
                                      domProps: {
                                        value: _vm.additionSessionCreditInput
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.additionSessionCreditInput =
                                            $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlInputButton", {
                                      staticClass: "rounded-full",
                                      attrs: {
                                        type: "outlined",
                                        icon: "plus",
                                        dense: ""
                                      },
                                      on: {
                                        clicked: function($event) {
                                          _vm.additionSessionCreditInput =
                                            Number(
                                              _vm.additionSessionCreditInput
                                            ) + 1
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("BlTextBody3", {
                                  staticClass: "text-slate-700",
                                  attrs: { text: "Credits" }
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.typeInput === "CreditTransaction::Subtraction"
                    ? _c("div", { staticClass: "flex flex-col gap-4 px-8" }, [
                        _c(
                          "div",
                          { staticClass: "grid grid-cols-2 gap-4" },
                          [
                            _c("BlSelectBox", {
                              class: {
                                "col-span-2":
                                  !_vm.transactionInput ||
                                  !_vm.transactionInput.expiration_date
                              },
                              attrs: {
                                label: "Source of active credit",
                                asterisk: "",
                                search: "",
                                placeholder: "Select active credits",
                                options: _vm.transactionOptions
                              },
                              on: {
                                change: function($event) {
                                  _vm.transactionIdInput = $event
                                }
                              },
                              model: {
                                value: _vm.transactionIdInput,
                                callback: function($$v) {
                                  _vm.transactionIdInput = $$v
                                },
                                expression: "transactionIdInput"
                              }
                            }),
                            _vm._v(" "),
                            _vm.transactionInput &&
                            _vm.transactionInput.expiration_date
                              ? _c("BlInputDate", {
                                  attrs: {
                                    input: {
                                      label: "Expiration date",
                                      model:
                                        _vm.transactionInput.expiration_date,
                                      disabled: true
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.transactionInput
                          ? _c(
                              "div",
                              { staticClass: "flex flex-col gap-4" },
                              [
                                _vm._l(_vm.subtractionServicesInput, function(
                                  service,
                                  idx
                                ) {
                                  return _c("div", { key: service.id }, [
                                    _c("div", { staticClass: "flex" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "px-2 rounded-t bg-slate-400"
                                        },
                                        [
                                          _c("BlTextBody3", {
                                            attrs: {
                                              text: service.package_item_name
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center justify-center gap-3 px-4 py-2 rounded rounded-tl-none bg-slate-200"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex flex-col items-center gap-1"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex items-center justify-center w-20 text-6xl font-bold h-18 text-slate-500"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      service.remaining_session_credit -
                                                        service
                                                          .scheduled_credits
                                                          .total_credits
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("BlTextBody3", {
                                              attrs: { text: "Unused credits" }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mb-6 text-6xl font-bold text-slate-500"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  -\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex flex-col items-center gap-1"
                                          },
                                          [
                                            _c("input", {
                                              staticClass:
                                                "items-center justify-center w-40 text-6xl font-bold text-center border rounded outline-none fle h-18 border-slate-500 focus:border-light-purple",
                                              class: [
                                                service.remaining_session_credit -
                                                  service.scheduled_credits
                                                    .total_credits <=
                                                0
                                                  ? "text-slate-500"
                                                  : "text-dark-purple-100"
                                              ],
                                              attrs: {
                                                type: "number",
                                                name: "credit_count",
                                                id: "credit_count",
                                                min: 0,
                                                max:
                                                  service.remaining_session_credit -
                                                  service.scheduled_credits
                                                    .total_credits,
                                                disabled:
                                                  service.remaining_session_credit -
                                                    service.scheduled_credits
                                                      .total_credits <=
                                                  0
                                              },
                                              domProps: {
                                                value:
                                                  _vm.subtractionServicesInput[
                                                    idx
                                                  ].subtract_credit
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.onInputSubtractCredits(
                                                    idx,
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("BlTextBody3", {
                                              attrs: {
                                                text: "Subtracted amount"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mb-6 text-6xl font-bold text-slate-500"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  =\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex flex-col items-center gap-1"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex items-center justify-center w-20 text-6xl font-bold h-18 text-slate-500",
                                                class:
                                                  service.remaining_session_credit -
                                                    service.scheduled_credits
                                                      .total_credits <
                                                  _vm.subtractionServicesInput[
                                                    idx
                                                  ].subtract_credit
                                                    ? "text-error-300"
                                                    : "text-slate-500"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      service.remaining_session_credit -
                                                        service
                                                          .scheduled_credits
                                                          .total_credits -
                                                        _vm
                                                          .subtractionServicesInput[
                                                          idx
                                                        ].subtract_credit
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("BlTextBody3", {
                                              attrs: { text: "Updated credits" }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ])
                                }),
                                _vm._v(" "),
                                _c("div", [
                                  _c("div", { staticClass: "flex" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "px-2 rounded-t bg-slate-400"
                                      },
                                      [
                                        _c("BlTextBody3", {
                                          attrs: { text: "Reschedule credits" }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center justify-center gap-3 px-4 py-2 rounded rounded-tl-none bg-slate-200"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-col items-center gap-1"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex items-center justify-center w-20 text-6xl font-bold h-18 text-slate-500"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.transactionInput
                                                      .remaining_reschedule_credit ===
                                                      null
                                                      ? "∞"
                                                      : _vm.transactionInput
                                                          .remaining_reschedule_credit
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("BlTextBody3", {
                                            attrs: { text: "Current credits" }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mb-6 text-6xl font-bold text-slate-500"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  -\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-col items-center gap-1"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.subtractionRescheduleCreditInput,
                                                expression:
                                                  "subtractionRescheduleCreditInput"
                                              }
                                            ],
                                            staticClass:
                                              "flex items-center justify-center w-40 text-6xl font-bold text-center border rounded outline-none h-18 border-slate-500 focus:border-light-purple",
                                            class: [
                                              !_vm.transactionInput
                                                .remaining_reschedule_credit
                                                ? "text-slate-500"
                                                : "text-dark-purple-100"
                                            ],
                                            attrs: {
                                              type: "number",
                                              name: "credit_count",
                                              id: "credit_count",
                                              min: 0,
                                              max:
                                                _vm.transactionInput
                                                  .remaining_reschedule_credit ||
                                                0,
                                              disabled: !_vm.transactionInput
                                                .remaining_reschedule_credit
                                            },
                                            domProps: {
                                              value:
                                                _vm.subtractionRescheduleCreditInput
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.subtractionRescheduleCreditInput =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody3", {
                                            attrs: { text: "Subtracted amount" }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mb-6 text-6xl font-bold text-slate-500"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  =\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-col items-center gap-1"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex items-center justify-center w-20 text-6xl font-bold h-18",
                                              class:
                                                _vm.transactionInput
                                                  .remaining_reschedule_credit !==
                                                  null &&
                                                _vm.transactionInput
                                                  .remaining_reschedule_credit -
                                                  _vm.subtractionRescheduleCreditInput <
                                                  0
                                                  ? "text-error-300"
                                                  : "text-slate-500"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.transactionInput
                                                      .remaining_reschedule_credit ===
                                                      null
                                                      ? "∞"
                                                      : _vm.transactionInput
                                                          .remaining_reschedule_credit -
                                                          _vm.subtractionRescheduleCreditInput
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("BlTextBody3", {
                                            attrs: { text: "Updated credits" }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ])
                              ],
                              2
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "px-8" },
                    [
                      _c("BlInputText", {
                        attrs: { input: _vm.reasonInput },
                        on: { changed: _vm.inputHandler }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.typeInput === "CreditTransaction::Addition"
                    ? _c(
                        "div",
                        { staticClass: "flex items-center gap-2 px-8" },
                        [
                          _c("BlInputText", {
                            attrs: { input: _vm.additionPricePerCreditInput },
                            on: { changed: _vm.inputHandler }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pt-6" },
                            [
                              _c("BlIcon", {
                                staticClass: "w-6 h-6",
                                attrs: { icon: "arrow-right", color: "slate-6" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("BlInputText", {
                            attrs: {
                              input: {
                                label: "Total price",
                                disabled: true,
                                model: _vm.priceFormats(_vm.additionTotalPrice),
                                prefix: _vm.currentCenter.currency_sym,
                                prefixSpace: "3rem"
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.typeInput === "CreditTransaction::Addition"
                    ? _c("div", { staticClass: "flex flex-col gap-4 mb-4" }, [
                        _c("div", {
                          staticClass: "flex-shrink-0 w-full h-5 bg-grey-100"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex flex-col gap-4 px-8" }, [
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-2" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      _vm.setExpirationDateInput = !_vm.setExpirationDateInput
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pl-2 pr-4",
                                      style: { transform: "scale(1.375)" }
                                    },
                                    [
                                      _c("BlInputToggle", {
                                        attrs: {
                                          checked: _vm.setExpirationDateInput
                                        },
                                        on: {
                                          changed: function($event) {
                                            _vm.setExpirationDateInput = !_vm.setExpirationDateInput
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("BlTextSubtitle1", {
                                    attrs: { text: "Set expiration date" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "The expiration date determines the last day credits can be used to book an appointment—unused credits will be lost after this date, but booked appointments remain valid even if they occur later."
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.setExpirationDateInput
                            ? _c(
                                "div",
                                {
                                  staticClass: "flex items-center w-2/3 gap-2"
                                },
                                [
                                  _c("BlInputDate", {
                                    attrs: {
                                      input: _vm.expirationDateInput,
                                      disabledManualInput: ""
                                    },
                                    on: { changed: _vm.onInputExpirationDate }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pt-6" },
                                    [
                                      _c("BlIcon", {
                                        staticClass: "w-6 h-6",
                                        attrs: { icon: "horizontal-arrow" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pt-6" },
                                    [
                                      _c("BlInputText", {
                                        attrs: {
                                          input: _vm.expirationDaysInput
                                        },
                                        on: {
                                          changed: _vm.onInputExpirationDays
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "flex-shrink-0 w-full h-5 bg-grey-100"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex flex-col gap-4 px-8" }, [
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-2" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center cursor-pointer",
                                  on: {
                                    click: function($event) {
                                      _vm.setMaximumRescheduleInput = !_vm.setMaximumRescheduleInput
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pl-2 pr-4",
                                      style: { transform: "scale(1.375)" }
                                    },
                                    [
                                      _c("BlInputToggle", {
                                        attrs: {
                                          checked: _vm.setMaximumRescheduleInput
                                        },
                                        on: {
                                          changed: function($event) {
                                            _vm.setMaximumRescheduleInput = !_vm.setMaximumRescheduleInput
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("BlTextSubtitle1", {
                                    attrs: { text: "Set maximum reschedules" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "If the reschedule limit is not specified, sessions using this credit can be rescheduled infinitely."
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.setMaximumRescheduleInput
                            ? _c(
                                "div",
                                { staticClass: "grid grid-cols-2 gap-2" },
                                [
                                  _c("BlInputText", {
                                    attrs: {
                                      input: _vm.maximumRescheduleInput
                                    },
                                    on: { changed: _vm.inputHandler }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center justify-between gap-4 px-8" },
                [
                  _c("BlInputButton", {
                    attrs: { type: "plain", label: "Cancel" },
                    on: {
                      clicked: function($event) {
                        return _vm.$emit("close-modal")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-4" },
                    [
                      _vm.enableAppointment
                        ? _c("BlInputButton", {
                            attrs: { type: "outlined", label: "Back" },
                            on: {
                              clicked: function($event) {
                                _vm.step = "select_method"
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: {
                          label: "Create",
                          disabled: _vm.isDisabledSubmit,
                          loading: _vm.submitLoading
                        },
                        on: { clicked: _vm.onCreate }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "select_package"
          ? _c("div", { staticClass: "flex flex-col gap-8 pb-8" }, [
              _c(
                "div",
                {
                  staticClass: "flex flex-col gap-4 px-8",
                  style: { width: "calc(100vw - 16rem)" }
                },
                [
                  _c(
                    "div",
                    [
                      _c("BlInputSearch", {
                        staticClass: "w-80",
                        attrs: { input: _vm.searchInput },
                        on: { changed: _vm.onInputSearch }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.fetchLoading
                    ? _c(
                        "div",
                        { staticClass: "grid w-full h-64 place-items-center" },
                        [_c("div", { staticClass: "blum-loader" })]
                      )
                    : !_vm.creditPackages.length
                    ? _c(
                        "div",
                        { staticClass: "grid w-full h-64 place-items-center" },
                        [
                          _vm.searchInput.model
                            ? _c("BlTextBody2", {
                                staticClass: "text-center text-slate-700",
                                attrs: {
                                  text: "Oops, the package(s) not found."
                                }
                              })
                            : _c("BlTextBody2", {
                                staticClass: "text-center text-slate-700",
                                attrs: {
                                  text:
                                    "Oops, there are no package(s) available at this center."
                                }
                              })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "relative pb-4 overflow-auto rounded bg-slate-100 scrollbar-lg",
                          style: { maxHeight: "calc(100vh - 24rem)" }
                        },
                        [
                          _c("div", {
                            staticClass: "flex-shrink-0 h-4 bg-slate-100"
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "sticky top-0 z-20 flex items-center flex-grow rounded-t bg-slate-300",
                              attrs: { id: "package-header" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sticky left-0 z-10 flex pl-6 bg-slate-100"
                                },
                                [
                                  _c(
                                    "BlTooltip",
                                    {
                                      staticClass:
                                        "flex items-center flex-shrink-0 h-12 px-4 border-t border-l border-r rounded-tl w-60 bg-slate-300 border-slate-400"
                                    },
                                    [
                                      _c("BlTextSubtitle3", {
                                        staticClass: "truncate",
                                        attrs: { text: "Package name" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "BlTooltip",
                                {
                                  staticClass:
                                    "flex items-center flex-shrink-0 w-32 h-12 px-4 border-t bg-slate-300 border-slate-400",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "tooltip",
                                        fn: function() {
                                          return [
                                            _c("div", { staticClass: "w-32" }, [
                                              _vm._v("Number of items")
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    2544216725
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c("BlTextSubtitle3", {
                                    staticClass: "truncate",
                                    attrs: { text: "Number of items" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "BlTooltip",
                                {
                                  staticClass:
                                    "flex items-center flex-shrink-0 w-32 h-12 px-4 border-t bg-slate-300 border-slate-400"
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    staticClass: "truncate",
                                    attrs: { text: "Status" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "BlTooltip",
                                {
                                  staticClass:
                                    "flex items-center flex-shrink-0 w-32 h-12 px-4 border-t bg-slate-300 border-slate-400"
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    staticClass: "truncate",
                                    attrs: { text: "Total credits" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "BlTooltip",
                                {
                                  staticClass:
                                    "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t bg-slate-300 border-slate-400"
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    staticClass: "truncate",
                                    attrs: { text: "Total price" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "BlTooltip",
                                {
                                  staticClass:
                                    "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t bg-slate-300 border-slate-400"
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    staticClass: "truncate",
                                    attrs: { text: "Expiration date" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "BlTooltip",
                                {
                                  staticClass:
                                    "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t bg-slate-300 border-slate-400"
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    staticClass: "truncate",
                                    attrs: { text: "Max. reschedule" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "BlTooltip",
                                {
                                  staticClass:
                                    "flex items-center flex-grow flex-shrink-0 h-12 px-4 border-t w-100 bg-slate-300 border-slate-400"
                                },
                                [
                                  _c("BlTextSubtitle3", {
                                    staticClass: "truncate",
                                    attrs: { text: "Description" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sticky right-0 z-10 flex pr-6 bg-slate-100"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center flex-shrink-0 w-4 h-12 border-t border-r rounded-tr bg-slate-300 border-slate-400"
                                    },
                                    [
                                      _c("BlTextSubtitle3", {
                                        attrs: { text: "" }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.creditPackages, function(
                            creditPackage,
                            idx
                          ) {
                            return _c("PackageItem", {
                              key: creditPackage.id,
                              attrs: {
                                creditPackage: creditPackage,
                                isLast: idx + 1 === _vm.creditPackages.length,
                                useSelect: "",
                                selected:
                                  _vm.packageIdInput === creditPackage.id
                              },
                              on: {
                                "change-select": function($event) {
                                  _vm.packageIdInput = creditPackage.id
                                }
                              }
                            })
                          })
                        ],
                        2
                      ),
                  _vm._v(" "),
                  _vm.totalCreditPackages > 25
                    ? _c(
                        "div",
                        [
                          _c("BlInputPagination", {
                            attrs: {
                              page: _vm.page,
                              perPage: _vm.perPage,
                              total: _vm.totalCreditPackages
                            },
                            on: {
                              changed: _vm.changePage,
                              "changed-per-page": _vm.changePerPage
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center justify-between gap-4 px-8" },
                [
                  _c("BlInputButton", {
                    attrs: { type: "plain", label: "Cancel" },
                    on: {
                      clicked: function($event) {
                        return _vm.$emit("close-modal")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-4" },
                    [
                      _c("BlInputButton", {
                        attrs: { type: "outlined", label: "Back" },
                        on: {
                          clicked: function($event) {
                            _vm.step = "select_method"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: {
                          label: "Preview package",
                          disabled: _vm.isDisabledSubmit
                        },
                        on: {
                          clicked: function($event) {
                            _vm.step = "preview_package"
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.step === "preview_package"
          ? _c("div", { staticClass: "flex flex-col gap-4 pb-8" }, [
              _c(
                "div",
                {
                  staticClass: "overflow-y-auto",
                  style: { width: "40rem", maxHeight: "calc(100vh - 14rem)" }
                },
                [
                  _vm.fetchLoading
                    ? _c(
                        "div",
                        { staticClass: "grid w-full h-100 place-items-center" },
                        [_c("div", { staticClass: "blum-loader" })]
                      )
                    : _c("div", { staticClass: "flex flex-col gap-4" }, [
                        _c(
                          "div",
                          { staticClass: "flex flex-col gap-4 px-8" },
                          [
                            _c("BlInputText", {
                              attrs: {
                                input: {
                                  label: "Package name",
                                  asterisk: true,
                                  model: _vm.packageInput.name,
                                  disabled: true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("BlInputText", {
                              attrs: {
                                input: {
                                  label: "Description",
                                  textarea: true,
                                  model: _vm.packageInput.description,
                                  disabled: true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col gap-2" },
                              [
                                _c("BlTextSubtitle1", {
                                  attrs: { text: "Add package items" }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "text-slate-700",
                                  attrs: {
                                    text:
                                      "You can add multiple items to a package."
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "grid grid-cols-3 gap-4 px-4 py-2 border rounded bg-slate-100 border-slate-300"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-center gap-1"
                                  },
                                  [
                                    _c("BlTextSubtitle1", {
                                      attrs: {
                                        text: _vm.packageInput.number_of_items
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody3", {
                                      staticClass: "text-slate-700",
                                      attrs: { text: "Total items" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-center gap-1"
                                  },
                                  [
                                    _c("BlTextSubtitle1", {
                                      attrs: {
                                        text: _vm.packageInput.total_credits
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlTextBody3", {
                                      staticClass: "text-slate-700",
                                      attrs: { text: "Total credits" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col items-center gap-1"
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c("BlTextSubtitle1", {
                                          attrs: {
                                            text: _vm.currentCenter.currency_sym
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextSubtitle1", {
                                          attrs: {
                                            text: _vm.priceFormats(
                                              _vm.packageInput.total_price
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("BlTextBody3", {
                                      staticClass: "text-slate-700",
                                      attrs: { text: "Total price" }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(
                              _vm.packageInput.package_services.filter(function(
                                i
                              ) {
                                return i.package_item.status === "active"
                              }),
                              function(item) {
                                return _c(
                                  "div",
                                  {
                                    key: item.id,
                                    staticClass:
                                      "flex flex-col gap-4 px-4 py-4 border rounded bg-slate-100 border-slate-300"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex items-end gap-2" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex-grow" },
                                          [
                                            _c("BlSelectBox", {
                                              attrs: {
                                                label: "Item",
                                                asterisk: "",
                                                options: [
                                                  {
                                                    value: item.package_item.id,
                                                    label:
                                                      item.package_item.name
                                                  }
                                                ],
                                                disabled: ""
                                              },
                                              model: {
                                                value: item.package_item.id,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item.package_item,
                                                    "id",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.package_item.id"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("BlInputButton", {
                                          attrs: {
                                            type: "plain",
                                            icon: "delete",
                                            disabled: ""
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-col items-center gap-1 px-4 py-3 rounded bg-slate-300"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center gap-3"
                                          },
                                          [
                                            _c("BlInputButton", {
                                              staticClass: "rounded-full",
                                              attrs: {
                                                type: "outlined",
                                                icon: "minus",
                                                dense: "",
                                                disabled: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("input", {
                                              staticClass:
                                                "flex items-center justify-center h-20 text-6xl font-bold text-center border rounded outline-none w-104 border-slate-500 text-dark-purple-100 focus:border-light-purple",
                                              attrs: {
                                                type: "number",
                                                name: "credit_count_" + item.id,
                                                id: "credit_count_" + item.id,
                                                disabled: ""
                                              },
                                              domProps: {
                                                value: item.session_credit
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("BlInputButton", {
                                              staticClass: "rounded-full",
                                              attrs: {
                                                type: "outlined",
                                                icon: "plus",
                                                dense: "",
                                                disabled: ""
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("BlTextBody3", {
                                          staticClass: "text-slate-700",
                                          attrs: { text: "Credits" }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "flex items-center gap-2"
                                      },
                                      [
                                        _c("BlInputText", {
                                          attrs: {
                                            input: {
                                              label: "Standard retail price",
                                              model: _vm.priceFormats(
                                                item.standard_retail_price
                                              ),
                                              prefix:
                                                _vm.currentCenter.currency_sym,
                                              prefixSpace: "3rem",
                                              disabled: true
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "pt-6" },
                                          [
                                            _c("BlIcon", {
                                              staticClass: "w-6 h-6",
                                              attrs: {
                                                icon: "horizontal-arrow",
                                                color: "slate-6"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("BlInputText", {
                                          attrs: {
                                            input: {
                                              label: "Total price",
                                              model: _vm.priceFormats(
                                                item.total_price
                                              ),
                                              prefix:
                                                _vm.currentCenter.currency_sym,
                                              prefixSpace: "3rem",
                                              disabled: true
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "flex-shrink-0 w-full h-5 bg-grey-100"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex flex-col gap-4 px-8" }, [
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-2" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex items-center" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pl-2 pr-4",
                                      style: { transform: "scale(1.375)" }
                                    },
                                    [
                                      _c("BlInputToggle", {
                                        attrs: {
                                          checked:
                                            _vm.packageInput.expiration_date !==
                                            null,
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("BlTextSubtitle1", {
                                    attrs: { text: "Set expiration date" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "The expiration date determines the last day credits can be used to book an appointment—unused credits will be lost after this date, but booked appointments remain valid even if they occur later."
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.packageInput.expiration_date !== null
                            ? _c(
                                "div",
                                {
                                  staticClass: "flex items-center w-2/3 gap-2"
                                },
                                [
                                  _c("BlInputDate", {
                                    attrs: {
                                      input: {
                                        label: "Expiration date",
                                        asterisk: true,
                                        model: _vm.getDateFromToday(
                                          _vm.packageInput.expiration_date
                                        ),
                                        disabled: true
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pt-6" },
                                    [
                                      _c("BlIcon", {
                                        staticClass: "w-6 h-6",
                                        attrs: { icon: "horizontal-arrow" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pt-6" },
                                    [
                                      _c("BlInputText", {
                                        attrs: {
                                          input: {
                                            model:
                                              _vm.packageInput.expiration_date,
                                            inputType: "number",
                                            prefix: "in",
                                            prefixSpace: "2.5rem",
                                            suffix: "days",
                                            disabled: true
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "flex-shrink-0 w-full h-5 bg-grey-100"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex flex-col gap-4 px-8" }, [
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-2" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex items-center" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pl-2 pr-4",
                                      style: { transform: "scale(1.375)" }
                                    },
                                    [
                                      _c("BlInputToggle", {
                                        attrs: {
                                          checked:
                                            _vm.packageInput
                                              .reschedule_credit !== null,
                                          disabled: ""
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("BlTextSubtitle1", {
                                    attrs: { text: "Set maximum reschedules" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "If the reschedule limit is not specified, sessions using this credit can be rescheduled infinitely."
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.packageInput.reschedule_credit !== null
                            ? _c(
                                "div",
                                { staticClass: "grid grid-cols-2 gap-2" },
                                [
                                  _c("BlInputText", {
                                    attrs: {
                                      input: {
                                        label: "Maximum reschedule allowed",
                                        model:
                                          _vm.packageInput.reschedule_credit,
                                        inputType: "number",
                                        suffix: "time(s)",
                                        disabled: true
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center justify-between gap-4 px-8" },
                [
                  _c("BlInputButton", {
                    attrs: { type: "plain", label: "Cancel" },
                    on: {
                      clicked: function($event) {
                        return _vm.$emit("close-modal")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-4" },
                    [
                      _c("BlInputButton", {
                        attrs: { type: "outlined", label: "Back" },
                        on: {
                          clicked: function($event) {
                            _vm.step = "select_package"
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("BlInputButton", {
                        attrs: {
                          label: "Use package",
                          disabled: _vm.isDisabledSubmit,
                          loading: _vm.submitLoading
                        },
                        on: { clicked: _vm.onCreateWithPackage }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.creditMinusHandlingOpen
        ? _c(
            "BlBackdrop",
            { attrs: { title: "Credit balance adjustment", footer: false } },
            [
              _c("div", { staticClass: "mb-8" }, [
                _c("div", { staticClass: "flex flex-col gap-4 px-8 mb-4" }, [
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        attrs: { text: "Your current credit balance is " }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "font-bold",
                        attrs: { text: _vm.availableCredits + ". " }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", { attrs: { text: "Adding " } }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "font-bold",
                        attrs: { text: _vm.addingCredits + " " }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: { text: "new credits will adjust your " }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: { text: "balance to a final total of: " }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center justify-center gap-1 py-3 rounded bg-slate-200"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center text-6xl font-bold h-18 text-dark-purple-100"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.finalAvailableCredits) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("BlTextBody3", {
                        attrs: { text: "Final available credit(s)" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex items-center justify-end gap-4 px-8 pt-4"
                  },
                  [
                    _c("BlInputButton", {
                      attrs: { type: "plain", label: "Cancel" },
                      on: {
                        clicked: function($event) {
                          _vm.creditMinusHandlingOpen = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.source === "manual"
                      ? _c("BlInputButton", {
                          attrs: {
                            label: "Confirm and create",
                            disabled: _vm.isDisabledSubmit,
                            loading: _vm.submitLoading
                          },
                          on: { clicked: _vm.onCreate }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.source === "package"
                      ? _c("BlInputButton", {
                          staticClass: "max-w-64",
                          attrs: {
                            label: "Confirm and use " + _vm.packageInput.name,
                            disabled: _vm.isDisabledSubmit,
                            loading: _vm.submitLoading
                          },
                          on: { clicked: _vm.onCreateWithPackage }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c6ee2d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c6ee2d7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/creditTransaction/NewCreditTransactionModal.vue
// module id = null
// module chunks = 